<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="sm"
    spinner-variant="primary"
  >
    <b-card>
      <h1>{{ $t("TimeZone") }}</h1>
      <form
        name="staff_form"
        method="post"
        v-on:submit.prevent="$event.preventDefault()"
      >
        <div class="vx-row flex">
          <span class="ml-4 mr-3 mt-1">{{ $t("AutoDetectTimezone") }}</span>
          <b-form-checkbox
            v-model="auto_detect_tz"
            size="lg"
            name="cell_width"
            switch
          >
          </b-form-checkbox>
        </div>

        <div class="vx-row">
          <!-- required -->
          <!-- Must be a valid email -->
          <div class="vx-col w-full">
            <v-select
              class="w-full mt-5"
              v-validate="'required'"
              v-model="timeZone"
              :options="options"
              :reduce="(label) => label.timezone"
              label="timezone"
              name="is_premium"
              id="is_premium"
              :data-vv-as="$t('TimeZone')"
              :placeholder="$t('SelectTimeZone')"
              :clearable="false"
              :disabled="auto_detect_tz"
            >
              <template v-slot:option="option">
                <span :class="option.icon">{{ option.timezone }} </span>
                <feather-icon
                  v-if="timeZone && timeZone === option.timezone"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('is_premium')"
              >{{ errors.first("is_premium") }}</span
            >
          </div>
        </div>
        <div class="mt-5 col-xs-10 offset-xs-1 center">
          <TimezoneMapPicker
            :default-value="timeZone"
            :show-drop-down="false"
            @hover="mapHoverHandler"
            @timezone="timezoneHandler"
          ></TimezoneMapPicker>
        </div>
        <div class="vx-row">
          <div class="vx-col" id="update">
            <b-button
              type="filled"
              variant="primary"
              @click.prevent="submitForm"
              class="mt-5 border-primary"
              >{{ $t("Submit") }}</b-button
            >
          </div>
        </div>
      </form>
    </b-card>
  </b-overlay>
</template>
<script>
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import TimezoneMapPicker from "@/layouts/components/timezone-map-picker.vue";
import $ from "jquery";
export default {
  components: {
    vSelect,
    TimezoneMapPicker,
  },
  data() {
    return {
      timezoneSelector: {
        hoverTz: null,
        selectedTz: null,
      },
      timeZone: "",
      auto_detect_tz: false,
      options: [],
      role: "staff",
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
    };
  },
  watch: {
    auto_detect_tz(auto) {
      if (auto) {
        this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.timezoneSelector.hoverTz = this.timezoneSelector.selectedTz =
          this.timeZone;
      }
    },
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },
  created() {
    this.role = this.$store.getters.currentUser.user_role;
    this.getstaffs();
    this.showTimeZones();
    this.loadLocale(this.$i18n.locale);
  },
  methods: {
    mapHoverHandler(event) {
      if (!this.auto_detect_tz) this.timezoneSelector.hoverTz = event;
    },
    async timezoneHandler(timezone) {
      if (!this.auto_detect_tz) this.timeZone = timezone;
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },

    /**
     *  submitForm method for submit timezone record in a timezone list
     **/
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addTimeZones();
        }
      });
    },
    /**
     *  showTimeZone method for show record in a timezone list
     **/
    showTimeZones() {
      const tz = this.$store.state.auth.currentUser.timezone;
      this.auto_detect_tz = this.$store.state.auth.currentUser.auto_detect_tz;
      this.timeZone = tz;
      this.timezoneSelector.hoverTz = tz;
      this.timezoneSelector.selectedTz = tz;
    },

    /**
     *  addstaffs method for add record in a staff list
     **/
    async addTimeZones() {
      this.show = true;

      try {
        await this.$store.dispatch("AddStaffTimeZone", {
          staff_id: this.$store.state.auth.currentUser.staff_id,
          timezone: this.timeZone,
          auto_detect_tz: this.auto_detect_tz,
        });
        const currentUser = { ...this.$store.state.auth.currentUser };

        if (this.auto_detect_tz == false)
          this.$store.commit("SET_DO_NOT_ASK_FOR_TZ_CHANGE", true);
        else this.$store.commit("SET_DO_NOT_ASK_FOR_TZ_CHANGE", false);
        currentUser.timezone = this.timeZone;
        currentUser.auto_detect_tz = this.auto_detect_tz;
        this.$store.commit("SET_USER", currentUser);
        this.$toasted.show(this.$t("TimeZoneUpdated"), {
          className: "top-alert",
          position: "top-center",
          type: "success",
          duration: 2000,
        });
      } catch (error) {
        console.error(error);
        this.$log.error(
          "File : views/company/settings/TimeZone.vue | Function : addstaffs() | Error :",
          error
        );
        this.show = false;
        // Error response

        this.error =
          this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
            ? this.$t(error.replace(/[\s\/]/g, ""))
            : error;
        this.$toasted.show(this.error, {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
      }
      this.show = false;
    },

    /**
     *  getstaffs method get all companies from company list
     **/

    getstaffs() {
      this.show = true;
      this.$store
        .dispatch("GetTimeZone")
        .then((res) => {
          this.options = res.data.data;
          this.show = false;
          //   if (res.data.data != null) this.staffs = res.data.data;
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getstaffs() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>
<style>
.center {
  margin: auto;
  text-align: center;
  padding: 10px;
}
</style>
<style lang="stylus">
#department {
  margin-top: 20px;
}
</style>
<style lang="stylus">
#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}

.contact_number {
  padding: 8px !important;
}

#contact_label {
  margin-top: 15px;
}
</style>










